export default __webpack_public_path__ + "static/maitakes-08adac95f44af2538d87111a8a37ac5c.webp";